




























import { Component, Watch } from 'vue-property-decorator';
import { Dialog, DialogValue, DialogValueTypeEnum, IAssetParameterValue, AssetParameterValue } from '@models';
import FormatParametersFormTypeBase from '../FormatParametersFormTypeBase/FormatParametersFormTypeBase';
import { Utility } from '../Utility';

@Component
export default class FormatParametersFormVideoType extends FormatParametersFormTypeBase {
  name = 'format-parameters-form-video-type';

  filePreview = new Dialog({
    formRef: 'filePreview',
    headline: 'Video preview',
    okText: 'Download',
    values: [new DialogValue({
      type: DialogValueTypeEnum.video,
      id: "video_preview",
      label: "Video preview"
    })]
  });

  jsonValue: IAssetParameterValue;

  get inputPlaceholder() {
    return this.file?.name || this.jsonValue?.UploadedFilename || 'Default video';
  }

  get file() {
    return this.local.file;
  }

  set file(file: File) {
    if (!file || typeof (file) === 'undefined') {
      if (this.isFileSelected) {
        this.$refs['fileSelector'].lazyValue = this.file;
      }
      return;
    };
    this.handleFileSelectionChange(file);
  }

  get isFileSelected() {
    return (this.file && typeof (this.file) !== 'undefined');
  }

  handleFileSelectionChange(file: File) {
    const jsonFile = new AssetParameterValue();
    jsonFile.UploadedFilename = file.name;

    this.update(v => {
      v.file = file;
      v.value = JSON.stringify(jsonFile);
      this.filePreview = null;
    });
  }

  onFileSelectorClear(event: any) {
    this.update(v => {
      v.file = null;
      v.value = null;
    });

    this.jsonValue = null;
  }

  get isPreviewAvailable(): boolean {
    return (this.file && this.file.size > 0) || !!this.jsonValue?.AssetPath;
  }

  previewVideo() {
    Utility.previewFileInModalDialog(this.file, this.filePreview, this.previewPath, this.jsonValue);
  }

  @Watch('value.value')
  updateJson() {
    try {
      if (this.value?.value && this.value?.value !== "") {
        this.jsonValue = JSON.parse(this.value.value);
      }
    } catch (e) {
      this.notification.Error("An error occurred while reading video parameter");
    }
  }

  created() {
    this.updateJson();
  }
}
